import { useAuthStore } from '@/core/auth/auth'

/**
 * Permission rule (keep this simple):
 *
 * 1. Access check — use can('page…') / can('action…') or v-can="'…'"
 *    - key is true on the logged-in user → allow
 *    - otherwise → deny
 *    - admin role → always allow
 *
 * 2. Helper loads — use skipPermissionCheck: true on axios
 *    When the user already may open a screen/drawer, supporting data
 *    (equipment list, services, QBO classes/locations, radius servers, …)
 *    must load without requiring separate page.* keys.
 *    Do NOT use skip for create/update/delete of those resources.
 */
export function can(permissionKey: string): boolean {
  if (!permissionKey) return false

  const authStore = useAuthStore()
  const user = authStore.user
  if (!user) return false

  if (user.role === 'admin') return true

  return user.permissions?.[permissionKey] === true
}
